// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.14.0 (commit 3ac273e970212dd613e57f4c312c49a9ab8ccb50).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AddCorsOriginReducer from "./add_cors_origin_reducer";
import AppHeartbeatReducer from "./app_heartbeat_reducer";
import AppOfflineReducer from "./app_offline_reducer";
import AssignUserRoleReducer from "./assign_user_role_reducer";
import BootstrapPlatformAdminReducer from "./bootstrap_platform_admin_reducer";
import ClearChannelConfigReducer from "./clear_channel_config_reducer";
import ClearLaunchOptionsReducer from "./clear_launch_options_reducer";
import ClearNotificationsReducer from "./clear_notifications_reducer";
import ClearProjectAppChannelPinReducer from "./clear_project_app_channel_pin_reducer";
import CompleteCommandReducer from "./complete_command_reducer";
import CompleteDownloadReducer from "./complete_download_reducer";
import CompleteUploadProgressReducer from "./complete_upload_progress_reducer";
import CreateAppReducer from "./create_app_reducer";
import CreateUploadProgressReducer from "./create_upload_progress_reducer";
import CreateVersionReducer from "./create_version_reducer";
import DeleteAppReducer from "./delete_app_reducer";
import DeleteDraftVersionReducer from "./delete_draft_version_reducer";
import DismissNotificationReducer from "./dismiss_notification_reducer";
import FailDownloadReducer from "./fail_download_reducer";
import FinalizeFileReducer from "./finalize_file_reducer";
import GetModuleInfoReducer from "./get_module_info_reducer";
import LinkExistingChunkReducer from "./link_existing_chunk_reducer";
import PauseDownloadReducer from "./pause_download_reducer";
import PostRestoreNormalizeReducer from "./post_restore_normalize_reducer";
import PublishVersionReducer from "./publish_version_reducer";
import QueueDownloadReducer from "./queue_download_reducer";
import QueueLaunchReducer from "./queue_launch_reducer";
import QueueOpenFolderReducer from "./queue_open_folder_reducer";
import QueueSyncReducer from "./queue_sync_reducer";
import QueueUninstallReducer from "./queue_uninstall_reducer";
import QueueUploadReducer from "./queue_upload_reducer";
import QueueVerifyReducer from "./queue_verify_reducer";
import RecordInstallReducer from "./record_install_reducer";
import RegisterAdminServiceReducer from "./register_admin_service_reducer";
import RegisterChunkMetadataReducer from "./register_chunk_metadata_reducer";
import RegisterClientTypeReducer from "./register_client_type_reducer";
import RegisterFileReducer from "./register_file_reducer";
import RegisterServiceIdentityReducer from "./register_service_identity_reducer";
import RemoveCorsOriginReducer from "./remove_cors_origin_reducer";
import RemoveModuleUserReducer from "./remove_module_user_reducer";
import RemoveServiceIdentityReducer from "./remove_service_identity_reducer";
import ResumeDownloadReducer from "./resume_download_reducer";
import SendNotificationReducer from "./send_notification_reducer";
import SetAppMaintainerOrgsReducer from "./set_app_maintainer_orgs_reducer";
import SetChannelConfigReducer from "./set_channel_config_reducer";
import SetChannelVersionReducer from "./set_channel_version_reducer";
import SetLaunchOptionsReducer from "./set_launch_options_reducer";
import SetLauncherBrokerConfigReducer from "./set_launcher_broker_config_reducer";
import SetModuleConfigReducer from "./set_module_config_reducer";
import SetModuleUserRoleReducer from "./set_module_user_role_reducer";
import SetProjectAppChannelPinReducer from "./set_project_app_channel_pin_reducer";
import SetProjectScopeReducer from "./set_project_scope_reducer";
import SetProjectTenantConfigReducer from "./set_project_tenant_config_reducer";
import SetUploadTotalsReducer from "./set_upload_totals_reducer";
import StartCommandReducer from "./start_command_reducer";
import StartDownloadReducer from "./start_download_reducer";
import StripVersionFilesReducer from "./strip_version_files_reducer";
import TransferAdminServiceReducer from "./transfer_admin_service_reducer";
import UninstallReducer from "./uninstall_reducer";
import UnpublishVersionReducer from "./unpublish_version_reducer";
import UpdateAppReducer from "./update_app_reducer";
import UpdateDownloadProgressReducer from "./update_download_progress_reducer";
import UpdateUploadProgressReducer from "./update_upload_progress_reducer";
import UpdateUsernameReducer from "./update_username_reducer";
import UpdateVersionReducer from "./update_version_reducer";

// Import all procedure arg schemas
import * as GetAppVersionDownloadUrlsProcedure from "./get_app_version_download_urls_procedure";
import * as GetAppVersionUploadUrlsProcedure from "./get_app_version_upload_urls_procedure";

// Import all table schema definitions
import AllLauncherUsersRow from "./all_launcher_users_table";
import AppRow from "./app_table";
import AppChannelConfigRow from "./app_channel_config_table";
import AppMaintainerOrgRow from "./app_maintainer_org_table";
import AppVersionRow from "./app_version_table";
import ChannelVersionRow from "./channel_version_table";
import ChunkHashIndexRow from "./chunk_hash_index_table";
import ChunkStoreRow from "./chunk_store_table";
import DownloadStartedEventRow from "./download_started_event_table";
import FileChunkRefRow from "./file_chunk_ref_table";
import FileRegisteredEventRow from "./file_registered_event_table";
import ModuleConfigRow from "./module_config_table";
import ModuleUserRow from "./module_user_table";
import MyAppStatusRow from "./my_app_status_table";
import MyCommandHistoryRow from "./my_command_history_table";
import MyCommandsRow from "./my_commands_table";
import MyConnectedClientsRow from "./my_connected_clients_table";
import MyDownloadProgressRow from "./my_download_progress_table";
import MyInstalledVersionsRow from "./my_installed_versions_table";
import MyLaunchOptionsRow from "./my_launch_options_table";
import MyNotificationsRow from "./my_notifications_table";
import MyOrgAppChannelConfigsRow from "./my_org_app_channel_configs_table";
import MyOrgAppVersionsRow from "./my_org_app_versions_table";
import MyOrgAppsRow from "./my_org_apps_table";
import MyOrgChannelVersionsRow from "./my_org_channel_versions_table";
import MyOrgCorsOriginRow from "./my_org_cors_origin_table";
import MyOrgProjectAppChannelPinsRow from "./my_org_project_app_channel_pins_table";
import MyOrgUsersRow from "./my_org_users_table";
import MyUploadProgressRow from "./my_upload_progress_table";
import ProjectAppChannelPinRow from "./project_app_channel_pin_table";
import UploadCompletedEventRow from "./upload_completed_event_table";
import UploadProgressCreatedEventRow from "./upload_progress_created_event_table";
import VersionCreatedEventRow from "./version_created_event_table";
import VersionFileRow from "./version_file_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  app: __table({
    name: 'app',
    indexes: [
      { accessor: 'app_id', name: 'app_app_id_idx_btree', algorithm: 'btree', columns: [
        'appId',
      ] },
      { accessor: 'org_id', name: 'app_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
    ],
    constraints: [
      { name: 'app_app_id_key', constraint: 'unique', columns: ['appId'] },
    ],
  }, AppRow),
  appChannelConfig: __table({
    name: 'app_channel_config',
    indexes: [
      { accessor: 'app_channel_key', name: 'app_channel_config_app_channel_key_idx_btree', algorithm: 'btree', columns: [
        'appChannelKey',
      ] },
      { accessor: 'app_id', name: 'app_channel_config_app_id_idx_btree', algorithm: 'btree', columns: [
        'appId',
      ] },
      { accessor: 'id', name: 'app_channel_config_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'app_channel_config_app_channel_key_key', constraint: 'unique', columns: ['appChannelKey'] },
      { name: 'app_channel_config_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, AppChannelConfigRow),
  appMaintainerOrg: __table({
    name: 'app_maintainer_org',
    indexes: [
      { accessor: 'app_id', name: 'app_maintainer_org_app_id_idx_btree', algorithm: 'btree', columns: [
        'appId',
      ] },
    ],
    constraints: [
    ],
  }, AppMaintainerOrgRow),
  appVersion: __table({
    name: 'app_version',
    indexes: [
      { accessor: 'app_id', name: 'app_version_app_id_idx_btree', algorithm: 'btree', columns: [
        'appId',
      ] },
      { accessor: 'version_id', name: 'app_version_version_id_idx_btree', algorithm: 'btree', columns: [
        'versionId',
      ] },
    ],
    constraints: [
      { name: 'app_version_version_id_key', constraint: 'unique', columns: ['versionId'] },
    ],
  }, AppVersionRow),
  channelVersion: __table({
    name: 'channel_version',
    indexes: [
      { accessor: 'app_channel_key', name: 'channel_version_app_channel_key_idx_btree', algorithm: 'btree', columns: [
        'appChannelKey',
      ] },
      { accessor: 'app_id', name: 'channel_version_app_id_idx_btree', algorithm: 'btree', columns: [
        'appId',
      ] },
      { accessor: 'id', name: 'channel_version_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'channel_version_app_channel_key_key', constraint: 'unique', columns: ['appChannelKey'] },
      { name: 'channel_version_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ChannelVersionRow),
  chunkHashIndex: __table({
    name: 'chunk_hash_index',
    indexes: [
      { accessor: 'hash', name: 'chunk_hash_index_hash_idx_btree', algorithm: 'btree', columns: [
        'hash',
      ] },
    ],
    constraints: [
      { name: 'chunk_hash_index_hash_key', constraint: 'unique', columns: ['hash'] },
    ],
  }, ChunkHashIndexRow),
  chunkStore: __table({
    name: 'chunk_store',
    indexes: [
      { accessor: 'hash', name: 'chunk_store_hash_idx_btree', algorithm: 'btree', columns: [
        'hash',
      ] },
    ],
    constraints: [
      { name: 'chunk_store_hash_key', constraint: 'unique', columns: ['hash'] },
    ],
  }, ChunkStoreRow),
  downloadStartedEvent: __table({
    name: 'download_started_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, DownloadStartedEventRow),
  fileChunkRef: __table({
    name: 'file_chunk_ref',
    indexes: [
      { accessor: 'file_id', name: 'file_chunk_ref_file_id_idx_btree', algorithm: 'btree', columns: [
        'fileId',
      ] },
      { accessor: 'ref_id', name: 'file_chunk_ref_ref_id_idx_btree', algorithm: 'btree', columns: [
        'refId',
      ] },
    ],
    constraints: [
      { name: 'file_chunk_ref_ref_id_key', constraint: 'unique', columns: ['refId'] },
    ],
  }, FileChunkRefRow),
  fileRegisteredEvent: __table({
    name: 'file_registered_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, FileRegisteredEventRow),
  moduleConfig: __table({
    name: 'module_config',
    indexes: [
      { accessor: 'id', name: 'module_config_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'module_config_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ModuleConfigRow),
  moduleUser: __table({
    name: 'module_user',
    indexes: [
      { accessor: 'identity', name: 'module_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'module_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ModuleUserRow),
  projectAppChannelPin: __table({
    name: 'project_app_channel_pin',
    indexes: [
      { accessor: 'app_id', name: 'project_app_channel_pin_app_id_idx_btree', algorithm: 'btree', columns: [
        'appId',
      ] },
      { accessor: 'id', name: 'project_app_channel_pin_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'org_id', name: 'project_app_channel_pin_org_id_idx_btree', algorithm: 'btree', columns: [
        'orgId',
      ] },
      { accessor: 'pin_key', name: 'project_app_channel_pin_pin_key_idx_btree', algorithm: 'btree', columns: [
        'pinKey',
      ] },
      { accessor: 'project', name: 'project_app_channel_pin_project_idx_btree', algorithm: 'btree', columns: [
        'project',
      ] },
    ],
    constraints: [
      { name: 'project_app_channel_pin_id_key', constraint: 'unique', columns: ['id'] },
      { name: 'project_app_channel_pin_pin_key_key', constraint: 'unique', columns: ['pinKey'] },
    ],
  }, ProjectAppChannelPinRow),
  uploadCompletedEvent: __table({
    name: 'upload_completed_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, UploadCompletedEventRow),
  uploadProgressCreatedEvent: __table({
    name: 'upload_progress_created_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, UploadProgressCreatedEventRow),
  versionCreatedEvent: __table({
    name: 'version_created_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, VersionCreatedEventRow),
  versionFile: __table({
    name: 'version_file',
    indexes: [
      { accessor: 'file_id', name: 'version_file_file_id_idx_btree', algorithm: 'btree', columns: [
        'fileId',
      ] },
      { accessor: 'version_id', name: 'version_file_version_id_idx_btree', algorithm: 'btree', columns: [
        'versionId',
      ] },
    ],
    constraints: [
      { name: 'version_file_file_id_key', constraint: 'unique', columns: ['fileId'] },
    ],
  }, VersionFileRow),
  allLauncherUsers: __table({
    name: 'all_launcher_users',
    indexes: [
    ],
    constraints: [
    ],
  }, AllLauncherUsersRow),
  myAppStatus: __table({
    name: 'my_app_status',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAppStatusRow),
  myCommandHistory: __table({
    name: 'my_command_history',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCommandHistoryRow),
  myCommands: __table({
    name: 'my_commands',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCommandsRow),
  myConnectedClients: __table({
    name: 'my_connected_clients',
    indexes: [
    ],
    constraints: [
    ],
  }, MyConnectedClientsRow),
  myDownloadProgress: __table({
    name: 'my_download_progress',
    indexes: [
    ],
    constraints: [
    ],
  }, MyDownloadProgressRow),
  myInstalledVersions: __table({
    name: 'my_installed_versions',
    indexes: [
    ],
    constraints: [
    ],
  }, MyInstalledVersionsRow),
  myLaunchOptions: __table({
    name: 'my_launch_options',
    indexes: [
    ],
    constraints: [
    ],
  }, MyLaunchOptionsRow),
  myNotifications: __table({
    name: 'my_notifications',
    indexes: [
    ],
    constraints: [
    ],
  }, MyNotificationsRow),
  myOrgAppChannelConfigs: __table({
    name: 'my_org_app_channel_configs',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrgAppChannelConfigsRow),
  myOrgAppVersions: __table({
    name: 'my_org_app_versions',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrgAppVersionsRow),
  myOrgApps: __table({
    name: 'my_org_apps',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrgAppsRow),
  myOrgChannelVersions: __table({
    name: 'my_org_channel_versions',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrgChannelVersionsRow),
  myOrgCorsOrigin: __table({
    name: 'my_org_cors_origin',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrgCorsOriginRow),
  myOrgProjectAppChannelPins: __table({
    name: 'my_org_project_app_channel_pins',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrgProjectAppChannelPinsRow),
  myOrgUsers: __table({
    name: 'my_org_users',
    indexes: [
    ],
    constraints: [
    ],
  }, MyOrgUsersRow),
  myUploadProgress: __table({
    name: 'my_upload_progress',
    indexes: [
    ],
    constraints: [
    ],
  }, MyUploadProgressRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("add_cors_origin", AddCorsOriginReducer),
  __reducerSchema("app_heartbeat", AppHeartbeatReducer),
  __reducerSchema("app_offline", AppOfflineReducer),
  __reducerSchema("assign_user_role", AssignUserRoleReducer),
  __reducerSchema("bootstrap_platform_admin", BootstrapPlatformAdminReducer),
  __reducerSchema("clear_channel_config", ClearChannelConfigReducer),
  __reducerSchema("clear_launch_options", ClearLaunchOptionsReducer),
  __reducerSchema("clear_notifications", ClearNotificationsReducer),
  __reducerSchema("clear_project_app_channel_pin", ClearProjectAppChannelPinReducer),
  __reducerSchema("complete_command", CompleteCommandReducer),
  __reducerSchema("complete_download", CompleteDownloadReducer),
  __reducerSchema("complete_upload_progress", CompleteUploadProgressReducer),
  __reducerSchema("create_app", CreateAppReducer),
  __reducerSchema("create_upload_progress", CreateUploadProgressReducer),
  __reducerSchema("create_version", CreateVersionReducer),
  __reducerSchema("delete_app", DeleteAppReducer),
  __reducerSchema("delete_draft_version", DeleteDraftVersionReducer),
  __reducerSchema("dismiss_notification", DismissNotificationReducer),
  __reducerSchema("fail_download", FailDownloadReducer),
  __reducerSchema("finalize_file", FinalizeFileReducer),
  __reducerSchema("get_module_info", GetModuleInfoReducer),
  __reducerSchema("link_existing_chunk", LinkExistingChunkReducer),
  __reducerSchema("pause_download", PauseDownloadReducer),
  __reducerSchema("post_restore_normalize", PostRestoreNormalizeReducer),
  __reducerSchema("publish_version", PublishVersionReducer),
  __reducerSchema("queue_download", QueueDownloadReducer),
  __reducerSchema("queue_launch", QueueLaunchReducer),
  __reducerSchema("queue_open_folder", QueueOpenFolderReducer),
  __reducerSchema("queue_sync", QueueSyncReducer),
  __reducerSchema("queue_uninstall", QueueUninstallReducer),
  __reducerSchema("queue_upload", QueueUploadReducer),
  __reducerSchema("queue_verify", QueueVerifyReducer),
  __reducerSchema("record_install", RecordInstallReducer),
  __reducerSchema("register_admin_service", RegisterAdminServiceReducer),
  __reducerSchema("register_chunk_metadata", RegisterChunkMetadataReducer),
  __reducerSchema("register_client_type", RegisterClientTypeReducer),
  __reducerSchema("register_file", RegisterFileReducer),
  __reducerSchema("register_service_identity", RegisterServiceIdentityReducer),
  __reducerSchema("remove_cors_origin", RemoveCorsOriginReducer),
  __reducerSchema("remove_module_user", RemoveModuleUserReducer),
  __reducerSchema("remove_service_identity", RemoveServiceIdentityReducer),
  __reducerSchema("resume_download", ResumeDownloadReducer),
  __reducerSchema("send_notification", SendNotificationReducer),
  __reducerSchema("set_app_maintainer_orgs", SetAppMaintainerOrgsReducer),
  __reducerSchema("set_channel_config", SetChannelConfigReducer),
  __reducerSchema("set_channel_version", SetChannelVersionReducer),
  __reducerSchema("set_launch_options", SetLaunchOptionsReducer),
  __reducerSchema("set_launcher_broker_config", SetLauncherBrokerConfigReducer),
  __reducerSchema("set_module_config", SetModuleConfigReducer),
  __reducerSchema("set_module_user_role", SetModuleUserRoleReducer),
  __reducerSchema("set_project_app_channel_pin", SetProjectAppChannelPinReducer),
  __reducerSchema("set_project_scope", SetProjectScopeReducer),
  __reducerSchema("set_project_tenant_config", SetProjectTenantConfigReducer),
  __reducerSchema("set_upload_totals", SetUploadTotalsReducer),
  __reducerSchema("start_command", StartCommandReducer),
  __reducerSchema("start_download", StartDownloadReducer),
  __reducerSchema("strip_version_files", StripVersionFilesReducer),
  __reducerSchema("transfer_admin_service", TransferAdminServiceReducer),
  __reducerSchema("uninstall", UninstallReducer),
  __reducerSchema("unpublish_version", UnpublishVersionReducer),
  __reducerSchema("update_app", UpdateAppReducer),
  __reducerSchema("update_download_progress", UpdateDownloadProgressReducer),
  __reducerSchema("update_upload_progress", UpdateUploadProgressReducer),
  __reducerSchema("update_username", UpdateUsernameReducer),
  __reducerSchema("update_version", UpdateVersionReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("get_app_version_download_urls", GetAppVersionDownloadUrlsProcedure.params, GetAppVersionDownloadUrlsProcedure.returnType),
  __procedureSchema("get_app_version_upload_urls", GetAppVersionUploadUrlsProcedure.params, GetAppVersionUploadUrlsProcedure.returnType),
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `appChannelConfig` instead. This alias will be removed in the next major version. */
    readonly "app_channel_config": Omit<typeof tablesSchema.schemaType.tables["appChannelConfig"], "accessorName"> & { readonly accessorName: "app_channel_config" };
    /** @deprecated Use `appMaintainerOrg` instead. This alias will be removed in the next major version. */
    readonly "app_maintainer_org": Omit<typeof tablesSchema.schemaType.tables["appMaintainerOrg"], "accessorName"> & { readonly accessorName: "app_maintainer_org" };
    /** @deprecated Use `appVersion` instead. This alias will be removed in the next major version. */
    readonly "app_version": Omit<typeof tablesSchema.schemaType.tables["appVersion"], "accessorName"> & { readonly accessorName: "app_version" };
    /** @deprecated Use `channelVersion` instead. This alias will be removed in the next major version. */
    readonly "channel_version": Omit<typeof tablesSchema.schemaType.tables["channelVersion"], "accessorName"> & { readonly accessorName: "channel_version" };
    /** @deprecated Use `chunkHashIndex` instead. This alias will be removed in the next major version. */
    readonly "chunk_hash_index": Omit<typeof tablesSchema.schemaType.tables["chunkHashIndex"], "accessorName"> & { readonly accessorName: "chunk_hash_index" };
    /** @deprecated Use `chunkStore` instead. This alias will be removed in the next major version. */
    readonly "chunk_store": Omit<typeof tablesSchema.schemaType.tables["chunkStore"], "accessorName"> & { readonly accessorName: "chunk_store" };
    /** @deprecated Use `downloadStartedEvent` instead. This alias will be removed in the next major version. */
    readonly "download_started_event": Omit<typeof tablesSchema.schemaType.tables["downloadStartedEvent"], "accessorName"> & { readonly accessorName: "download_started_event" };
    /** @deprecated Use `fileChunkRef` instead. This alias will be removed in the next major version. */
    readonly "file_chunk_ref": Omit<typeof tablesSchema.schemaType.tables["fileChunkRef"], "accessorName"> & { readonly accessorName: "file_chunk_ref" };
    /** @deprecated Use `fileRegisteredEvent` instead. This alias will be removed in the next major version. */
    readonly "file_registered_event": Omit<typeof tablesSchema.schemaType.tables["fileRegisteredEvent"], "accessorName"> & { readonly accessorName: "file_registered_event" };
    /** @deprecated Use `moduleConfig` instead. This alias will be removed in the next major version. */
    readonly "module_config": Omit<typeof tablesSchema.schemaType.tables["moduleConfig"], "accessorName"> & { readonly accessorName: "module_config" };
    /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
    readonly "module_user": Omit<typeof tablesSchema.schemaType.tables["moduleUser"], "accessorName"> & { readonly accessorName: "module_user" };
    /** @deprecated Use `projectAppChannelPin` instead. This alias will be removed in the next major version. */
    readonly "project_app_channel_pin": Omit<typeof tablesSchema.schemaType.tables["projectAppChannelPin"], "accessorName"> & { readonly accessorName: "project_app_channel_pin" };
    /** @deprecated Use `uploadCompletedEvent` instead. This alias will be removed in the next major version. */
    readonly "upload_completed_event": Omit<typeof tablesSchema.schemaType.tables["uploadCompletedEvent"], "accessorName"> & { readonly accessorName: "upload_completed_event" };
    /** @deprecated Use `uploadProgressCreatedEvent` instead. This alias will be removed in the next major version. */
    readonly "upload_progress_created_event": Omit<typeof tablesSchema.schemaType.tables["uploadProgressCreatedEvent"], "accessorName"> & { readonly accessorName: "upload_progress_created_event" };
    /** @deprecated Use `versionCreatedEvent` instead. This alias will be removed in the next major version. */
    readonly "version_created_event": Omit<typeof tablesSchema.schemaType.tables["versionCreatedEvent"], "accessorName"> & { readonly accessorName: "version_created_event" };
    /** @deprecated Use `versionFile` instead. This alias will be removed in the next major version. */
    readonly "version_file": Omit<typeof tablesSchema.schemaType.tables["versionFile"], "accessorName"> & { readonly accessorName: "version_file" };
    /** @deprecated Use `allLauncherUsers` instead. This alias will be removed in the next major version. */
    readonly "all_launcher_users": Omit<typeof tablesSchema.schemaType.tables["allLauncherUsers"], "accessorName"> & { readonly accessorName: "all_launcher_users" };
    /** @deprecated Use `myAppStatus` instead. This alias will be removed in the next major version. */
    readonly "my_app_status": Omit<typeof tablesSchema.schemaType.tables["myAppStatus"], "accessorName"> & { readonly accessorName: "my_app_status" };
    /** @deprecated Use `myCommandHistory` instead. This alias will be removed in the next major version. */
    readonly "my_command_history": Omit<typeof tablesSchema.schemaType.tables["myCommandHistory"], "accessorName"> & { readonly accessorName: "my_command_history" };
    /** @deprecated Use `myCommands` instead. This alias will be removed in the next major version. */
    readonly "my_commands": Omit<typeof tablesSchema.schemaType.tables["myCommands"], "accessorName"> & { readonly accessorName: "my_commands" };
    /** @deprecated Use `myConnectedClients` instead. This alias will be removed in the next major version. */
    readonly "my_connected_clients": Omit<typeof tablesSchema.schemaType.tables["myConnectedClients"], "accessorName"> & { readonly accessorName: "my_connected_clients" };
    /** @deprecated Use `myDownloadProgress` instead. This alias will be removed in the next major version. */
    readonly "my_download_progress": Omit<typeof tablesSchema.schemaType.tables["myDownloadProgress"], "accessorName"> & { readonly accessorName: "my_download_progress" };
    /** @deprecated Use `myInstalledVersions` instead. This alias will be removed in the next major version. */
    readonly "my_installed_versions": Omit<typeof tablesSchema.schemaType.tables["myInstalledVersions"], "accessorName"> & { readonly accessorName: "my_installed_versions" };
    /** @deprecated Use `myLaunchOptions` instead. This alias will be removed in the next major version. */
    readonly "my_launch_options": Omit<typeof tablesSchema.schemaType.tables["myLaunchOptions"], "accessorName"> & { readonly accessorName: "my_launch_options" };
    /** @deprecated Use `myNotifications` instead. This alias will be removed in the next major version. */
    readonly "my_notifications": Omit<typeof tablesSchema.schemaType.tables["myNotifications"], "accessorName"> & { readonly accessorName: "my_notifications" };
    /** @deprecated Use `myOrgAppChannelConfigs` instead. This alias will be removed in the next major version. */
    readonly "my_org_app_channel_configs": Omit<typeof tablesSchema.schemaType.tables["myOrgAppChannelConfigs"], "accessorName"> & { readonly accessorName: "my_org_app_channel_configs" };
    /** @deprecated Use `myOrgAppVersions` instead. This alias will be removed in the next major version. */
    readonly "my_org_app_versions": Omit<typeof tablesSchema.schemaType.tables["myOrgAppVersions"], "accessorName"> & { readonly accessorName: "my_org_app_versions" };
    /** @deprecated Use `myOrgApps` instead. This alias will be removed in the next major version. */
    readonly "my_org_apps": Omit<typeof tablesSchema.schemaType.tables["myOrgApps"], "accessorName"> & { readonly accessorName: "my_org_apps" };
    /** @deprecated Use `myOrgChannelVersions` instead. This alias will be removed in the next major version. */
    readonly "my_org_channel_versions": Omit<typeof tablesSchema.schemaType.tables["myOrgChannelVersions"], "accessorName"> & { readonly accessorName: "my_org_channel_versions" };
    /** @deprecated Use `myOrgCorsOrigin` instead. This alias will be removed in the next major version. */
    readonly "my_org_cors_origin": Omit<typeof tablesSchema.schemaType.tables["myOrgCorsOrigin"], "accessorName"> & { readonly accessorName: "my_org_cors_origin" };
    /** @deprecated Use `myOrgProjectAppChannelPins` instead. This alias will be removed in the next major version. */
    readonly "my_org_project_app_channel_pins": Omit<typeof tablesSchema.schemaType.tables["myOrgProjectAppChannelPins"], "accessorName"> & { readonly accessorName: "my_org_project_app_channel_pins" };
    /** @deprecated Use `myOrgUsers` instead. This alias will be removed in the next major version. */
    readonly "my_org_users": Omit<typeof tablesSchema.schemaType.tables["myOrgUsers"], "accessorName"> & { readonly accessorName: "my_org_users" };
    /** @deprecated Use `myUploadProgress` instead. This alias will be removed in the next major version. */
    readonly "my_upload_progress": Omit<typeof tablesSchema.schemaType.tables["myUploadProgress"], "accessorName"> & { readonly accessorName: "my_upload_progress" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.14.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "app_channel_config": "appChannelConfig",
  "app_maintainer_org": "appMaintainerOrg",
  "app_version": "appVersion",
  "channel_version": "channelVersion",
  "chunk_hash_index": "chunkHashIndex",
  "chunk_store": "chunkStore",
  "download_started_event": "downloadStartedEvent",
  "file_chunk_ref": "fileChunkRef",
  "file_registered_event": "fileRegisteredEvent",
  "module_config": "moduleConfig",
  "module_user": "moduleUser",
  "project_app_channel_pin": "projectAppChannelPin",
  "upload_completed_event": "uploadCompletedEvent",
  "upload_progress_created_event": "uploadProgressCreatedEvent",
  "version_created_event": "versionCreatedEvent",
  "version_file": "versionFile",
  "all_launcher_users": "allLauncherUsers",
  "my_app_status": "myAppStatus",
  "my_command_history": "myCommandHistory",
  "my_commands": "myCommands",
  "my_connected_clients": "myConnectedClients",
  "my_download_progress": "myDownloadProgress",
  "my_installed_versions": "myInstalledVersions",
  "my_launch_options": "myLaunchOptions",
  "my_notifications": "myNotifications",
  "my_org_app_channel_configs": "myOrgAppChannelConfigs",
  "my_org_app_versions": "myOrgAppVersions",
  "my_org_apps": "myOrgApps",
  "my_org_channel_versions": "myOrgChannelVersions",
  "my_org_cors_origin": "myOrgCorsOrigin",
  "my_org_project_app_channel_pins": "myOrgProjectAppChannelPins",
  "my_org_users": "myOrgUsers",
  "my_upload_progress": "myUploadProgress",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `appChannelConfig` instead. This alias will be removed in the next major version. */
  readonly "app_channel_config": __DbViewBase["appChannelConfig"];
  /** @deprecated Use `appMaintainerOrg` instead. This alias will be removed in the next major version. */
  readonly "app_maintainer_org": __DbViewBase["appMaintainerOrg"];
  /** @deprecated Use `appVersion` instead. This alias will be removed in the next major version. */
  readonly "app_version": __DbViewBase["appVersion"];
  /** @deprecated Use `channelVersion` instead. This alias will be removed in the next major version. */
  readonly "channel_version": __DbViewBase["channelVersion"];
  /** @deprecated Use `chunkHashIndex` instead. This alias will be removed in the next major version. */
  readonly "chunk_hash_index": __DbViewBase["chunkHashIndex"];
  /** @deprecated Use `chunkStore` instead. This alias will be removed in the next major version. */
  readonly "chunk_store": __DbViewBase["chunkStore"];
  /** @deprecated Use `downloadStartedEvent` instead. This alias will be removed in the next major version. */
  readonly "download_started_event": __DbViewBase["downloadStartedEvent"];
  /** @deprecated Use `fileChunkRef` instead. This alias will be removed in the next major version. */
  readonly "file_chunk_ref": __DbViewBase["fileChunkRef"];
  /** @deprecated Use `fileRegisteredEvent` instead. This alias will be removed in the next major version. */
  readonly "file_registered_event": __DbViewBase["fileRegisteredEvent"];
  /** @deprecated Use `moduleConfig` instead. This alias will be removed in the next major version. */
  readonly "module_config": __DbViewBase["moduleConfig"];
  /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
  readonly "module_user": __DbViewBase["moduleUser"];
  /** @deprecated Use `projectAppChannelPin` instead. This alias will be removed in the next major version. */
  readonly "project_app_channel_pin": __DbViewBase["projectAppChannelPin"];
  /** @deprecated Use `uploadCompletedEvent` instead. This alias will be removed in the next major version. */
  readonly "upload_completed_event": __DbViewBase["uploadCompletedEvent"];
  /** @deprecated Use `uploadProgressCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "upload_progress_created_event": __DbViewBase["uploadProgressCreatedEvent"];
  /** @deprecated Use `versionCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "version_created_event": __DbViewBase["versionCreatedEvent"];
  /** @deprecated Use `versionFile` instead. This alias will be removed in the next major version. */
  readonly "version_file": __DbViewBase["versionFile"];
  /** @deprecated Use `allLauncherUsers` instead. This alias will be removed in the next major version. */
  readonly "all_launcher_users": __DbViewBase["allLauncherUsers"];
  /** @deprecated Use `myAppStatus` instead. This alias will be removed in the next major version. */
  readonly "my_app_status": __DbViewBase["myAppStatus"];
  /** @deprecated Use `myCommandHistory` instead. This alias will be removed in the next major version. */
  readonly "my_command_history": __DbViewBase["myCommandHistory"];
  /** @deprecated Use `myCommands` instead. This alias will be removed in the next major version. */
  readonly "my_commands": __DbViewBase["myCommands"];
  /** @deprecated Use `myConnectedClients` instead. This alias will be removed in the next major version. */
  readonly "my_connected_clients": __DbViewBase["myConnectedClients"];
  /** @deprecated Use `myDownloadProgress` instead. This alias will be removed in the next major version. */
  readonly "my_download_progress": __DbViewBase["myDownloadProgress"];
  /** @deprecated Use `myInstalledVersions` instead. This alias will be removed in the next major version. */
  readonly "my_installed_versions": __DbViewBase["myInstalledVersions"];
  /** @deprecated Use `myLaunchOptions` instead. This alias will be removed in the next major version. */
  readonly "my_launch_options": __DbViewBase["myLaunchOptions"];
  /** @deprecated Use `myNotifications` instead. This alias will be removed in the next major version. */
  readonly "my_notifications": __DbViewBase["myNotifications"];
  /** @deprecated Use `myOrgAppChannelConfigs` instead. This alias will be removed in the next major version. */
  readonly "my_org_app_channel_configs": __DbViewBase["myOrgAppChannelConfigs"];
  /** @deprecated Use `myOrgAppVersions` instead. This alias will be removed in the next major version. */
  readonly "my_org_app_versions": __DbViewBase["myOrgAppVersions"];
  /** @deprecated Use `myOrgApps` instead. This alias will be removed in the next major version. */
  readonly "my_org_apps": __DbViewBase["myOrgApps"];
  /** @deprecated Use `myOrgChannelVersions` instead. This alias will be removed in the next major version. */
  readonly "my_org_channel_versions": __DbViewBase["myOrgChannelVersions"];
  /** @deprecated Use `myOrgCorsOrigin` instead. This alias will be removed in the next major version. */
  readonly "my_org_cors_origin": __DbViewBase["myOrgCorsOrigin"];
  /** @deprecated Use `myOrgProjectAppChannelPins` instead. This alias will be removed in the next major version. */
  readonly "my_org_project_app_channel_pins": __DbViewBase["myOrgProjectAppChannelPins"];
  /** @deprecated Use `myOrgUsers` instead. This alias will be removed in the next major version. */
  readonly "my_org_users": __DbViewBase["myOrgUsers"];
  /** @deprecated Use `myUploadProgress` instead. This alias will be removed in the next major version. */
  readonly "my_upload_progress": __DbViewBase["myUploadProgress"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `appChannelConfig` instead. This alias will be removed in the next major version. */
  readonly "app_channel_config": __TablesBase["appChannelConfig"];
  /** @deprecated Use `appMaintainerOrg` instead. This alias will be removed in the next major version. */
  readonly "app_maintainer_org": __TablesBase["appMaintainerOrg"];
  /** @deprecated Use `appVersion` instead. This alias will be removed in the next major version. */
  readonly "app_version": __TablesBase["appVersion"];
  /** @deprecated Use `channelVersion` instead. This alias will be removed in the next major version. */
  readonly "channel_version": __TablesBase["channelVersion"];
  /** @deprecated Use `chunkHashIndex` instead. This alias will be removed in the next major version. */
  readonly "chunk_hash_index": __TablesBase["chunkHashIndex"];
  /** @deprecated Use `chunkStore` instead. This alias will be removed in the next major version. */
  readonly "chunk_store": __TablesBase["chunkStore"];
  /** @deprecated Use `downloadStartedEvent` instead. This alias will be removed in the next major version. */
  readonly "download_started_event": __TablesBase["downloadStartedEvent"];
  /** @deprecated Use `fileChunkRef` instead. This alias will be removed in the next major version. */
  readonly "file_chunk_ref": __TablesBase["fileChunkRef"];
  /** @deprecated Use `fileRegisteredEvent` instead. This alias will be removed in the next major version. */
  readonly "file_registered_event": __TablesBase["fileRegisteredEvent"];
  /** @deprecated Use `moduleConfig` instead. This alias will be removed in the next major version. */
  readonly "module_config": __TablesBase["moduleConfig"];
  /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
  readonly "module_user": __TablesBase["moduleUser"];
  /** @deprecated Use `projectAppChannelPin` instead. This alias will be removed in the next major version. */
  readonly "project_app_channel_pin": __TablesBase["projectAppChannelPin"];
  /** @deprecated Use `uploadCompletedEvent` instead. This alias will be removed in the next major version. */
  readonly "upload_completed_event": __TablesBase["uploadCompletedEvent"];
  /** @deprecated Use `uploadProgressCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "upload_progress_created_event": __TablesBase["uploadProgressCreatedEvent"];
  /** @deprecated Use `versionCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "version_created_event": __TablesBase["versionCreatedEvent"];
  /** @deprecated Use `versionFile` instead. This alias will be removed in the next major version. */
  readonly "version_file": __TablesBase["versionFile"];
  /** @deprecated Use `allLauncherUsers` instead. This alias will be removed in the next major version. */
  readonly "all_launcher_users": __TablesBase["allLauncherUsers"];
  /** @deprecated Use `myAppStatus` instead. This alias will be removed in the next major version. */
  readonly "my_app_status": __TablesBase["myAppStatus"];
  /** @deprecated Use `myCommandHistory` instead. This alias will be removed in the next major version. */
  readonly "my_command_history": __TablesBase["myCommandHistory"];
  /** @deprecated Use `myCommands` instead. This alias will be removed in the next major version. */
  readonly "my_commands": __TablesBase["myCommands"];
  /** @deprecated Use `myConnectedClients` instead. This alias will be removed in the next major version. */
  readonly "my_connected_clients": __TablesBase["myConnectedClients"];
  /** @deprecated Use `myDownloadProgress` instead. This alias will be removed in the next major version. */
  readonly "my_download_progress": __TablesBase["myDownloadProgress"];
  /** @deprecated Use `myInstalledVersions` instead. This alias will be removed in the next major version. */
  readonly "my_installed_versions": __TablesBase["myInstalledVersions"];
  /** @deprecated Use `myLaunchOptions` instead. This alias will be removed in the next major version. */
  readonly "my_launch_options": __TablesBase["myLaunchOptions"];
  /** @deprecated Use `myNotifications` instead. This alias will be removed in the next major version. */
  readonly "my_notifications": __TablesBase["myNotifications"];
  /** @deprecated Use `myOrgAppChannelConfigs` instead. This alias will be removed in the next major version. */
  readonly "my_org_app_channel_configs": __TablesBase["myOrgAppChannelConfigs"];
  /** @deprecated Use `myOrgAppVersions` instead. This alias will be removed in the next major version. */
  readonly "my_org_app_versions": __TablesBase["myOrgAppVersions"];
  /** @deprecated Use `myOrgApps` instead. This alias will be removed in the next major version. */
  readonly "my_org_apps": __TablesBase["myOrgApps"];
  /** @deprecated Use `myOrgChannelVersions` instead. This alias will be removed in the next major version. */
  readonly "my_org_channel_versions": __TablesBase["myOrgChannelVersions"];
  /** @deprecated Use `myOrgCorsOrigin` instead. This alias will be removed in the next major version. */
  readonly "my_org_cors_origin": __TablesBase["myOrgCorsOrigin"];
  /** @deprecated Use `myOrgProjectAppChannelPins` instead. This alias will be removed in the next major version. */
  readonly "my_org_project_app_channel_pins": __TablesBase["myOrgProjectAppChannelPins"];
  /** @deprecated Use `myOrgUsers` instead. This alias will be removed in the next major version. */
  readonly "my_org_users": __TablesBase["myOrgUsers"];
  /** @deprecated Use `myUploadProgress` instead. This alias will be removed in the next major version. */
  readonly "my_upload_progress": __TablesBase["myUploadProgress"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

